import {
	AuthProvider as RbacAuthProvider,
	type AuthUser as RbacAuthUser,
	useAuth as useRbacAuth,
} from "@theg1group/rbac-ui";
import { type ReactNode, createElement } from "react";
import { fetchMe, logout } from "./api.ts";

export type User = RbacAuthUser;

async function fetchUser(): Promise<User | null> {
	try {
		const data = await fetchMe<User>();
		return { ...data, permissions: data.permissions ?? [], appAccess: data.appAccess ?? [] };
	} catch {
		return null;
	}
}

export function AuthProvider({ children }: { children: ReactNode }) {
	return createElement(RbacAuthProvider, { fetchUser, onLogout: logout, children });
}

export function useAuth() {
	const a = useRbacAuth();
	return { ...a, loading: a.isLoading };
}
